import React, { useState } from 'react';
import { Box, Typography, Paper, TextField, Button, Grid, FormControl, InputLabel, Select, MenuItem, InputAdornment } from '@mui/material';
import { Pix, Send } from '@mui/icons-material';

const PixTransferPage: React.FC = () => {
  const [keyType, setKeyType] = useState('cpf');
  const [pixKey, setPixKey] = useState('');
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Transfer:', { keyType, pixKey, amount, description });
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
        <Pix sx={{ mr: 1, verticalAlign: 'middle' }} />
        Transferência PIX
      </Typography>

      <Paper sx={{ p: 3, maxWidth: 600 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Tipo de Chave</InputLabel>
                <Select
                  value={keyType}
                  label="Tipo de Chave"
                  onChange={(e) => setKeyType(e.target.value)}
                >
                  <MenuItem value="cpf">CPF</MenuItem>
                  <MenuItem value="cnpj">CNPJ</MenuItem>
                  <MenuItem value="email">E-mail</MenuItem>
                  <MenuItem value="phone">Celular</MenuItem>
                  <MenuItem value="evp">Chave Aleatória</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                label="Chave PIX"
                value={pixKey}
                onChange={(e) => setPixKey(e.target.value)}
                placeholder="Digite a chave PIX do destinatário"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Valor"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                InputProps={{
                  startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                }}
                placeholder="0,00"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Descrição (opcional)"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                multiline
                rows={2}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                size="large"
                fullWidth
                startIcon={<Send />}
              >
                Transferir
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Box>
  );
};

export default PixTransferPage;
